import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";

/**
 * Persistent bottom CTA on mobile only. Appears after the visitor scrolls
 * past the hero (~500px) so it doesn't compete with the hero button, and
 * hides once they reach the footer area to avoid overlapping the final CTA.
 */
export function StickyMobileCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    let ticking = false;
    let lastVisible = visible;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const nearBottom =
          window.innerHeight + y >= document.documentElement.scrollHeight - 400;
        const next = y > 260 && !nearBottom;
        // Only update state on transitions — avoids re-render on every frame.
        if (next !== lastVisible) {
          lastVisible = next;
          setVisible(next);
        }
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`pointer-events-none fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] transition-all duration-300 md:hidden ${
        visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
      }`}
      aria-hidden={!visible}
    >
      <Link
        to="/kauppa"
        data-cta="sticky_mobile"
        tabIndex={visible ? 0 : -1}
        className="pointer-events-auto flex items-center justify-between gap-3 rounded-full bg-foreground px-5 py-3.5 text-sm font-medium text-background shadow-[0_18px_40px_-12px_rgb(60_40_20/0.55)]"
      >
        <span className="flex flex-col items-start leading-tight">
          <span>Katso Pikler-mallisto →</span>
        </span>
        <span
          aria-hidden
          className="flex h-8 w-8 items-center justify-center rounded-full bg-background/15"
        >
          →
        </span>
      </Link>
    </div>
  );
}